import { render } from "./modal-news.vue?vue&type=template&id=65567283&scoped=true"
import script from "./modal-news.vue?vue&type=script&lang=js"
export * from "./modal-news.vue?vue&type=script&lang=js"

import "./modal-news.vue?vue&type=style&index=0&id=65567283&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65567283"],['__file',"src/components/modal-news.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65567283"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65567283', __exports__)) {
    api.reload('65567283', __exports__)
  }
  
  module.hot.accept("./modal-news.vue?vue&type=template&id=65567283&scoped=true", () => {
    api.rerender('65567283', render)
  })

}


export default __exports__